import React, { useState } from 'react';
import axios from 'axios'; 
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Login = () => {
    const [msisdn, setMsisdn] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault(); 

        try {
            const url = `/checkuser/${msisdn}/${password}`;
            const response = await axios.get(url);

            console.log(response.data);

            if (response.data.exists === 1) {
                Cookies.set('msisdn', msisdn);
                Cookies.set('password', password);
                Cookies.set('status', response.data.exists);
                toast.success('Login success !!', {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setTimeout(() => {
                    navigate('/');
                }, 2000);
            } else {
                toast.error('User Invalid !!', {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setTimeout(() => {
                    navigate('/subscribe');
                }, 2000);
            }
        } catch (error) {
            console.error('There was an error!', error);
            toast.error('Invalid Credentials !!', {
                position: toast.POSITION.TOP_RIGHT,
            });
            setTimeout(() => {
                navigate('/subscribe');
            }, 2000);
        }
    };

    return (
        <div className='min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-500 via-blue-200 to-blue-500'>
            <div className='bg-white shadow-xl rounded-2xl p-8 w-full max-w-md mx-4'>
                <form className="space-y-6" onSubmit={handleSubmit}>
                    <p className='text-center text-3xl font-extrabold text-blue-700 drop-shadow-sm'>Sign in to enjoy!</p>

                    <div>
                        <label htmlFor="msisdn" className="block mb-2 text-sm font-medium text-gray-700">Phone number</label>
                        <input
                            type="number"
                            placeholder='+251'
                            id="msisdn"
                            className="bg-blue-50 border border-blue-200 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            required
                            value={msisdn}
                            onChange={(e) => setMsisdn(e.target.value)}
                        />
                    </div>

                    <div>
                        <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-700">Password</label>
                        <input
                            type="password"
                            id="password"
                            className="bg-blue-50 border border-blue-200 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    <button type="submit" className="w-full text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-semibold rounded-lg text-sm px-5 py-2.5 text-center transition duration-200">
                        Login
                    </button>
                </form>
            </div>
            <ToastContainer />
        </div>
    );
};

export default Login;
